import { jsxs as i, jsx as a } from "react/jsx-runtime";
import { makeClassesByStyles as l } from "../../../../utils/classes.js";
import { IconButton as n } from "../../../shared/components/icon-button/icon-button.js";
import e from "../../../../assets/b0107fbe.modal-header.module.css";
const m = l(e), u = ({
  className: t,
  handleBackClick: s,
  handleCloseClick: r,
  heading: o,
  subheading: d,
  variant: c = "secondary"
}) => (c = "secondary", /* @__PURE__ */ i("div", { className: m("ModalHeader", `--${c}`, t), children: [
  /* @__PURE__ */ a(
    n,
    {
      ...!s && { "aria-hidden": !0 },
      className: e["back-btn"],
      "data-testid": "back-btn",
      iconName: "chevron-left",
      onClick: s
    }
  ),
  /* @__PURE__ */ i("div", { className: e["heading-wrapper"], children: [
    /* @__PURE__ */ a("h2", { className: e.heading, ...!o && { "aria-hidden": !0 }, children: o }),
    /* @__PURE__ */ a("h3", { className: e.subheading, children: d })
  ] }),
  /* @__PURE__ */ a(
    n,
    {
      ...!r && { "aria-hidden": !0 },
      "aria-label": "close",
      className: e["close-btn"],
      iconName: "close",
      onClick: r
    }
  )
] }));
export {
  u as ModalHeader
};
